import { render, staticRenderFns } from "./ChangeInfo.vue?vue&type=template&id=6f8cba92&"
import script from "./ChangeInfo.vue?vue&type=script&lang=ts&"
export * from "./ChangeInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports